module.exports = __webpack_public_path__ + "img/giants-jazz.74138d0b.png";